import { render, staticRenderFns } from "./OrderableItemButton.vue?vue&type=template&id=26487cd4"
import script from "./OrderableItemButton.vue?vue&type=script&lang=js"
export * from "./OrderableItemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports